import dynamic from 'next/dynamic';

const EmbedComponent = dynamic(() => import(`./Embed`));

const components = {
    AUDIO: dynamic(() => import(`./Audio`)),
    CITA: dynamic(() => import(`./Cites`)),
    DESTACAT_RELACIONAT: dynamic(() => import(`./DestacatRelacionat`)),
    FLOURISH: dynamic(() => import(`./Flourish`)),
    IFRAME_3CAT: dynamic(() => import(`./Iframe3Cat`)),
    IMATGE: dynamic(() => import(`./ImatgeCos`)),
    IMATGE_RELACIONADA: dynamic(() => import(`./ImatgeCos`)),
    LINK: dynamic(() => import(`components/3catinfo/Enllac`)),
    NOTICIA_RELACIONADA: dynamic(() => import(`./NoticiaRelacionada`)),
    OPTA: dynamic(() => import(`./Opta`)),
    TEXT: dynamic(() => import(`./TextNoti`)),
    VIDEO: dynamic(() => import(`./Video`)),
    VIDEO_ANIMAT: dynamic(() => import(`./Video`)),
    BLUESKY: EmbedComponent,
    CARTO: EmbedComponent,
    DATAWRAPPER: EmbedComponent,
    FACEBOOK: EmbedComponent,
    INFOGRAM: EmbedComponent,
    INSTAGRAM: EmbedComponent,
    QUALIFIO: EmbedComponent,
    TIKTOK: EmbedComponent,
    TWITTER: EmbedComponent,
    YOUTUBE: EmbedComponent,
    VIMEO: EmbedComponent
};

export { components };
